import { useState } from 'react';
import { useIntl } from 'react-intl';

import SnackBar from 'client/components/ui/Snackbar/SnackBar';
import CollapsibleSnackBar from 'client/pages/MapPage/components/SnackBars/CollapsibleSnackBar/CollapsibleSnackBar';
import NavLink from 'client/components/aria/NavLink/NavLink';

import { mdiClose, mdiInformationOutline } from '@mdi/js';

import { HELP_PAGE } from 'client/utils/routes/routeConstants';

import styles from '../button.module.scss';
import Icon from '@mdi/react';
import Button from 'client/components/aria/Button/Button';
import stylesSnackBar from '../NetworkCoverageSnackBar/NetworkCoverageSnackBar.module.scss';

const NetworkCoverageSnackBar = () => {
    const intl = useIntl();
    const [visible, setVisible] = useState(true);

    const message = intl.formatMessage({ id: 'networkCoverageSnackBar.alert' }, {
        link: str => (
            <NavLink to={HELP_PAGE}>
                {str}
            </NavLink>
        )
    });

    const closeButton = <Button
        data-testid="NetworkCoverageSnackBar"
        variant="transparent"
        className={styles.button}
        aria-label={ intl.formatMessage({ id: 'general.closeNotification' }) }
        onPress={() => { setVisible(false); }}
    >
        <Icon path={mdiClose} size={1}/>
    </Button>;

    return (
        <>
            { visible && <SnackBar variant="info" endOfLine={closeButton}>
                <CollapsibleSnackBar
                    icon={mdiInformationOutline}
                    label={intl.formatMessage({ id: 'networkCoverageSnackBar.notification.label' })}
                    data-testid="NetworkCoverageSnackBar.alert"
                >
                    <span className={ stylesSnackBar.NetworkCoverageHelpUrl} data-testid="NetworkCoverageSnackBar.message">
                        {message}
                    </span>
                </CollapsibleSnackBar>
            </SnackBar>
            }
        </>
    );
};

export default NetworkCoverageSnackBar;
